// test936
(936 && 0);
